import { createCanonicalTableViewData } from '@streamlain/database-identity/database-view-defaults';

import type { GroupBy, GroupProperty } from '../../core/common/types.js';
import type { FilterGroup } from '../../core/filter/types.js';
import type { Sort } from '../../core/sort/types.js';
import { type BasicViewDataType, viewType } from '../../core/view/data-view.js';
import { TableSingleView } from './table-view-manager.js';

export const tableViewType = viewType('table');

export type TableViewColumn = {
  id: string;
  width: number;
  statCalcType?: string;
  hide?: boolean;
};
type DataType = {
  columns: TableViewColumn[];
  filter: FilterGroup;
  groupBy?: GroupBy;
  groupProperties?: GroupProperty[];
  sort?: Sort;
  header?: {
    titleColumn?: string;
    iconColumn?: string;
    imageColumn?: string;
  };
  /**
   * Cell display mode for the table view:
   * - 'collapsed': All cells show single line (truncated)
   * - 'expanded': All cells show full content (multi-line)
   * - 'smart': Only selected/focused row is expanded, others collapsed
   */
  cellDisplayMode?: 'collapsed' | 'expanded' | 'smart';
};
export type TableViewData = BasicViewDataType<
  typeof tableViewType.type,
  DataType
>;
export const tableViewModel = tableViewType.createModel<TableViewData>({
  defaultName: 'Table View',
  dataViewManager: TableSingleView,
  defaultData: viewManager => {
    return createCanonicalTableViewData(
      viewManager.dataSource
        .getBoundedPropertyIdsWindow()
        .propertyIds.map(id => ({
          id,
          type: viewManager.dataSource.propertyTypeGet(id) ?? '',
        }))
    );
  },
});
